import React from "react";
import { Form } from "react-bootstrap";

// Lot picker for the hearing-day pages: one hearing day can hold several lots (lot no + bank + product)
const HearingLotSelect = ({ lots, selectedLotKey, onChange }) => {
  if (!lots.length) return null;
  return (
    <div className="col-md-3">
      <Form.Select
        value={selectedLotKey}
        onChange={(e) => onChange(e.target.value)}
        className="form-control"
        style={{ fontSize: "13px" }}
        aria-label="Lot"
      >
        {lots.length > 1 && <option value="">Choose lot ({lots.length} lots this day)…</option>}
        {lots.map((lot) => (
          <option key={lot.key} value={lot.key}>
            {lot.label} ({lot.cases} case{lot.cases > 1 ? "s" : ""})
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default HearingLotSelect;
